import VueMeta from "vue-meta";
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About"),
  },
  {
    path: "/sandbox",
    name: "Sandbox",
    component: () => import("../views/Sandbox"),
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import("../views/Projects"),
  },
  {
    path: "/projects/trofi",
    name: "Trofi",
    component: () => import("../views/Projects/Trofi"),
  },
  {
    path: "/projects/heemans",
    name: "Heeman's",
    component: () => import("../views/Projects/Heemans"),
  },
  {
    path: "/projects/cloudview",
    name: "Cloudview",
    component: () => import("../views/Projects/Cloudview"),
  },
  {
    path: "/projects/100-days-of-dante",
    name: "100 Days Of Dante",
    component: () => import("../views/Projects/DaysOfDante"),
  },
  {
    path: "/projects/branton",
    name: "Branton",
    component: () => import("../views/Projects/Branton"),
  },
  {
    path: "/projects/heart2heart",
    name: "Heart2Heart",
    component: () => import("../views/Projects/Heart2Heart"),
  },
  {
    path: "/projects/high-tier",
    name: "HighTier",
    component: () => import("../views/Projects/HighTier"),
  },
  {
    path: "/projects/fuzion-flooring",
    name: "Fuzion Flooring",
    component: () => import("../views/Projects/FuzionFlooring"),
  },
  {
    path: "/projects/trade-in-trade-up",
    name: "Trade-In Trade-Up",
    component: () => import("../views/Projects/TradeInTradeUp"),
  },
  {
    path: "/projects/oxford-learning",
    name: "OxfordLearning",
    component: () => import("../views/Projects/OxfordLearning"),
  },
  {
    path: "/projects/techalliance",
    name: "TechAlliance",
    component: () => import("../views/Projects/TechAlliance"),
  },
  {
    path: "/projects/prepack-planner",
    name: "PrepackPlanner",
    component: () => import("../views/Projects/PrepackPlanner"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior() {
  // 	return new Promise((resolve) => {
  // 		setTimeout(() => {
  // 			resolve({ x: 0, y: 0 });
  // 		}, 100);
  // 	});
  // },
});

export default router;
